import styled from "styled-components";

export const FeedbackButton = styled.a`
  position: fixed;

  display: inline-block;

  right: 0;
  top: 50%;
  z-index: 10;

  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  padding: 6px 16px;
  background-color: #363636;
  color: white;

  border-top-right-radius: 16px;
  border-top-left-radius: 16px;

  transform: rotate(270deg) translateY(-50%);
  transform-origin: right center;

  @media (pointer: fine) {
    right: 16px;
  }
`;

export const FeedbackTag = styled.span`
  display: inline-block;
  color: #f98723;
  margin-right: 6px;
  font-weight: 600;
  transform: rotate(90deg);
`;
